import { useEffect, useState } from "react";
import { Download, Mail } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "../lib/api";
import { Button } from "../components/ui/button";

export default function Subscribers() {
  const [subs, setSubs] = useState([]);

  useEffect(() => {
    api.get("/subscribers").then((r) => setSubs(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);

  const exportCsv = () => {
    const rows = ["email,subscribed_at", ...subs.map((s) => `${s.email},${s.created_at}`)];
    const url = URL.createObjectURL(new Blob([rows.join("\n")], { type: "text/csv" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = "broward_local_subscribers.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="subscribers-page" className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-3xl font-bold tracking-tight text-[#1B2A4A]">Newsletter Subscribers</h1>
          <p className="text-sm text-[#475569] mt-1" data-testid="subscriber-count">
            {subs.length} early-access email{subs.length === 1 ? "" : "s"} collected from the coming soon page
          </p>
        </div>
        <Button variant="outline" data-testid="export-subscribers-button" onClick={exportCsv} disabled={subs.length === 0} className="border-[#E2E8F0]">
          <Download size={15} className="mr-2" /> Export CSV
        </Button>
      </div>

      <div className="bg-white border border-[#E2E8F0] rounded-xl overflow-hidden">
        <table className="w-full text-sm" data-testid="subscribers-table">
          <thead>
            <tr className="border-b border-[#E2E8F0] bg-[#F5F7FA] text-left">
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-[#94A3B8]">Email</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-[#94A3B8]">Source</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-[#94A3B8]">Subscribed</th>
            </tr>
          </thead>
          <tbody>
            {subs.length === 0 && (
              <tr>
                <td colSpan={3} className="px-4 py-10 text-center text-[#94A3B8]" data-testid="subscribers-empty">
                  <Mail size={20} className="mx-auto mb-2 text-[#CBD5E1]" />
                  No subscribers yet. Share the coming soon page to start collecting early-access emails.
                </td>
              </tr>
            )}
            {subs.map((s) => (
              <tr key={s.id} data-testid={`subscriber-row-${s.id}`} className="border-b border-[#F1F5F9]">
                <td className="px-4 py-3 font-medium text-[#0F172A]">{s.email}</td>
                <td className="px-4 py-3 text-[#475569] capitalize">{(s.source || "coming_soon").replace("_", " ")}</td>
                <td className="px-4 py-3 text-[#475569]">{new Date(s.created_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
